import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeatureCards from './components/FeatureCards';
import ArticleCardsSection from './components/ArticleCardsSection';
import ContentSection from './components/ContentSection';
import CtaSection from './components/CtaSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoospread.buzz';
const faviconUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Spread',
  url: siteUrl,
  description: 'The ultimate Sugargoo Spreadsheet resource hub — find organized product categories, detailed shopping guides, honest reviews, shipping cost breakdowns, and curated Sugargoo finds. Helping shoppers discover smarter since 2026.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Sugargoo Spread',
  url: siteUrl,
  logo: faviconUrl,
  description: 'Independent Sugargoo Spreadsheet resource platform providing organized product categories, shopping guides, reviews, and curated finds for international shoppers.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={orgSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ArticleCardsSection />
        <FeatureCards />
        <ContentSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}